/*
 * SPDX-FileCopyrightText: 2020 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: GPL-3.0-or-later
 */
export default class ScopedStorage {
    static GLOBAL_SCOPE_VOLATILE = 'nextcloud_vol';
    static GLOBAL_SCOPE_PERSISTENT = 'nextcloud_per';
    scope;
    wrapped;
    constructor(scope, wrapped, persistent) {
        this.scope = `${persistent ? ScopedStorage.GLOBAL_SCOPE_PERSISTENT : ScopedStorage.GLOBAL_SCOPE_VOLATILE}_${btoa(scope)}_`;
        this.wrapped = wrapped;
    }
    scopeKey(key) {
        return `${this.scope}${key}`;
    }
    setItem(key, value) {
        this.wrapped.setItem(this.scopeKey(key), value);
    }
    getItem(key) {
        return this.wrapped.getItem(this.scopeKey(key));
    }
    removeItem(key) {
        this.wrapped.removeItem(this.scopeKey(key));
    }
    clear() {
        Object.keys(this.wrapped)
            .filter((key) => key.startsWith(this.scope))
            .map(this.wrapped.removeItem.bind(this.wrapped));
    }
}
